import { Box, Flex, HStack } from '@skin-seoul/design-system';
import { Skeleton } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import React from 'react';

type VerticalProductCardSkeletonProps = ComponentProps<typeof Flex>;

export const VerticalProductCardSkeleton = ({ ...props }: VerticalProductCardSkeletonProps) => {
  return (
    <Flex direction="column" gap={{ base: 2, desktop: 4 }} width="100%" cursor="pointer" minWidth={0} {...props}>
      <Skeleton
        borderRadius="8px"
        overflow="hidden"
        height={{
          base: '200px',
          tablet: '300px',
        }}
        width="100%"
        minWidth={0}
        position="relative"
      />

      <Box display="flex" flexDirection="column" gap={3} width="100%" minWidth={0} borderRadius="0 0 8px 8px">
        <Box display="flex" flexDirection="column" gap={2} width="100%" minWidth={0}>
          <Skeleton borderRadius="4px" height="16px" width="120px" />
          <Skeleton borderRadius="4px" height="16px" width="100%" />
        </Box>

        <HStack alignItems="center" gap={2}>
          <Skeleton borderRadius="4px" height="20px" width="80px" />
          <Skeleton borderRadius="4px" height="20px" width="40px" />
        </HStack>

        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton borderRadius="4px" height="16px" width="60px" />
        </Box>
      </Box>
    </Flex>
  );
};
